import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const CalendarIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3V4H6C4.34315 4 3 5.34315 3 7V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V7C21 5.34315 19.6569 4 18 4H17V3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3V4H9V3ZM7 6V7C7 7.55228 7.44772 8 8 8C8.55229 8 9 7.55228 9 7V6H15V7C15 7.55228 15.4477 8 16 8C16.5523 8 17 7.55228 17 7V6H18C18.5523 6 19 6.44772 19 7V10H5V7C5 6.44772 5.44772 6 6 6H7ZM5 12V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V12H5Z"
    fill="currentColor"
  />,
  "CalendarIcon"
);
